// scroll to text-content section on click
$(".image-text-top-section .arrow-scroll").click(function(e) {
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#text-content").offset().top
    }, 300);
});